<template>
  <div>
    <vx-card titleIcon="SearchIcon" ref="filterCard" title="Adjust Log Summary" class="user-list-filters mb-8"
      :collapse-action="true">
      <sundry-item-adjust-stock-log-summary />
    </vx-card>
    <div class="vx-row">
      <div class="vx-col w-full">
        <vx-card title="SUNDRY ITEMS STOCK">
          <template slot="actions">
            <vs-button @click.stop="onClickDownloadFullSheet()" class="mr-4 mb-4" color="primary" type="filled">Download
              Stock Inventory Audit Log</vs-button>
          </template>
          <div slot="no-body" class="mt-4" v-can="'view-sundry-item-stock-inventory'">
            <vs-input icon-pack="feather" icon="icon-search" placeholder="Search" v-model="filters['search']"
              class="is-label-placeholder px-3 pb-5 w-full md:w-1/3 xl:w-1/7 rounded-full" />
            <vs-table id="sundry-item-list-table-log" :max-items="(meta.per_page) ? meta.per_page : 10" :data="items" sort
              :sst="true" stripe class="table-dark-inverted table-auto vs-con-loading__container">

              <template slot="thead">
                <vs-th width="10%" class="text-xs" sort-key="sundry_item_code">SUNDRY ITEM CODE</vs-th>
                <vs-th width="10%" class="text-xs" sort-key="sundry_product_code">PRODUCT CODE</vs-th>
                <vs-th width="10%" class="text-xs">PRODUCT NAME</vs-th>
                <vs-th width="15%" class="text-xs">CURRENT STOCK LEVEL (UNITS)</vs-th>
                <vs-th width="15%" class="text-xs">CONFIRMED ORDER STOCK ALLOCATION (UNITS)</vs-th>
                <vs-th width="15%" class="text-xs">AVAILABLE UNALLOCATED STOCK (UNITS)</vs-th>
                <vs-th width="15%" class="text-xs">ACTION</vs-th>
              </template>

              <template slot-scope="{data}">
                <vs-tr @click.native="onClickStockChange(data[indextr].id)" class="text-sm" style="cursor: pointer"
                  :key="indextr" v-for="(tr, indextr) in data">


                  <vs-td :data="data[indextr].sundry_item_code">
                    {{ data[indextr].sundry_item_code }}
                  </vs-td>

                  <vs-td :data="data[indextr].sundry_product_code">
                    {{ data[indextr].sundry_product_code }}
                  </vs-td>

                  <vs-td :data="data[indextr].sundry_product_name">
                    {{ data[indextr].sundry_product_name }}
                  </vs-td>

                  <vs-td class="font-bold" :data="data[indextr].current_stock_level">
                    {{ data[indextr].current_stock_level }}
                  </vs-td>

                  <vs-td class="font-bold" :data="data[indextr].confirmed_order_stock_allocation">
                    {{ data[indextr].confirmed_order_stock_allocation }}
                  </vs-td>

                  <vs-td class="font-bold" :data="data[indextr].available_unallocated_stock">
                    {{ data[indextr].available_unallocated_stock }}
                  </vs-td>

                  <vs-td>
                    <div class="vx-row">
                      <vx-tooltip text="View Activity Log" position="left">
                        <vs-button class="ml-3" @click.STOP="onClickStockChange(data[indextr].id)" size="small"
                          color="primary" type="border" icon-pack="feather" icon="icon-eye"></vs-button>
                      </vx-tooltip>
                      <vx-tooltip text="Download Log" position="left">
                        <vs-button class="ml-3" @click.stop="onClickDownloadSheet(data[indextr].id)" size="small"
                          color="warning" type="border" icon-pack="feather" icon="icon-download"></vs-button>
                      </vx-tooltip>
                    </div>
                  </vs-td>

                </vs-tr>
              </template>


            </vs-table>

            <vs-pagination v-on:changeMaxItems="changePage" :size-array="meta.total ? meta.total : 20"
              :max-items="perPage" description-body="Rows per page" description-connector="of" description-title="Records"
              description :description-items="descriptionItems" :total="(meta.last_page) ? meta.last_page : 0"
              v-model="page" class="p-5">
            </vs-pagination>


          </div>
        </vx-card>
      </div>
    </div>
    <sundry-item-stock-adjust-log-popup ref="sundryItemStockAdjustLogPopup" />
    <download-inventory-log-pop-up ref="downloadInventoryLogPopUp"/>
    <DownloadInventoryChangeLogPopUp ref="downloadInventoryChangeLogPopUp" />
  </div>
</template>

<script>
import vSelect from 'vue-select'
import { RepositoryFactory } from '@/repository/RepositoryFactory'
import Filter from '@/mixins/filter';
const InventoryRepository = RepositoryFactory.get('inventory')
import SuccessMessage from '@/mixins/SuccessMessage'
import ErrorMessages from '@/mixins/ErrorMessages'
import { defaultPagination, perPageList } from "@/constants/config";
import SundryItemStockAdjustLogPopup
  from "@/components/popups/activity-logs/stock-adjust/SundryItemStockAdjustLogPopup";
import SundryItemAdjustStockLogSummary from './SundryItemAdjustStockLogSummary.vue';
import DownloadInventoryChangeLogPopUp from '@/components/popups/activity-logs/inventory/DownloadInventoryChangeLogPopUp.vue';
import DownloadInventoryLogPopUp from '@/components/popups/activity-logs/inventory/DownloadInventoryLogPopUp.vue';

export default {
  name: 'SundryItemAllBatchList',
  data() {
    return {
      items: [],
      filters: {},
      page: 1,
      total: 0,
      meta: {},
      sort: '',
      perPage: defaultPagination,
      descriptionItems: perPageList,
    }
  },
  components: {
    "v-select": vSelect,
    SundryItemStockAdjustLogPopup,
    SundryItemAdjustStockLogSummary,
    DownloadInventoryChangeLogPopUp,
    DownloadInventoryLogPopUp,
  },
  mixins: [Filter, SuccessMessage, ErrorMessages],
  async mounted() {
  },
  methods: {
    async refreshData() {
      this.fetchSundryItemStockList()
    },
    async fetchSundryItemStockList() {
      await this.$vs.loading({
        container: '#sundry-item-list-table-log',
        scale: 0.45
      })
      try {
        const { data } = await InventoryRepository.getSundryItemStockList(this.page, this.filterQuery, this.perPage)
        this.items = data.data
        this.meta = data.meta
      } catch (e) {
        this.showWarningMessage('Something went wrong. Please try again!')
      }
      this.$vs.loading.close('#sundry-item-list-table-log > .con-vs-loading')
    },

    filterQueryUpdate() {
      this.fetchSundryItemStockList()
    },

    handleChangePage(page) {
      this.page = page;
      this.fetchSundryItemStockList()
    },
    handleSort(key, active) {
      if (key) {
        active = (active === 'desc') ? "-" : '';
        this.sort = active + key;
        this.fetchSundryItemStockList()
      }

    },
    changePage(index) {
      this.perPage = this.descriptionItems[index]
    },
    close() {
      this.activePrompt = false
    },
    onClickStockChange(id) {
      this.$refs.sundryItemStockAdjustLogPopup.openPopup(id)
    },
    onClickDownloadSheet(id) {
      this.$refs.downloadInventoryLogPopUp.openPopup(id, 'sundry-inventory')
    },
    async onClickDownloadFullSheet() {
      this.$refs.downloadInventoryChangeLogPopUp.openPopup('sundry-inventory')
    },
  },
  watch: {
    page() {
      this.fetchSundryItemStockList()
    },
    perPage() {
      this.fetchSundryItemStockList()
    }
  }
}
</script>


<style scoped>
.user-edit-popup>>>.vs-popup {
  min-height: 50% !important;
  min-width: 50% !important;
}

@media (min-width: 768px) and (max-width: 1319px) {
  .user-edit-popup>>>.vs-popup {
    min-height: 50% !important;
    min-width: 65% !important;
  }
}
</style>
